import React, { useCallback } from 'react'
import '../ConfigTable.css'
import './ProgKeyLabel.css'

export default function ProgKeyLabel({ keyName, setEditMode, isLocked, isJustCreated, kInfo }) {
  const handleClick = useCallback((e) => {
    setEditMode();
  }, [setEditMode]);
  
  return (
    <div className={`progKeyLabel ${isLocked ? 'progKeyLocked' : 'progKeyEditable'} ${isJustCreated ? 'justCreated' : ''} ${kInfo?.insight?.newItem ? 'insightNewItem' : ''}`} onClick={handleClick}>
      {keyName}
    </div>
  )
}
